import { Checkbox, Form, Grid, Text } from '@approvalmax/ui/src/components';
import { memo } from 'react';
import { useFormContext } from 'react-hook-form';
import { z } from 'zod';

import { schema } from '../../schema';
import { AddressFormPart } from '../AddressFormPart/AddressFormPart';
import { messages } from './StepForm.messages';

export const StepForm = memo(() => {
    const form = useFormContext<z.infer<typeof schema>>();

    const areCompanyAddressesEqual = form.watch('businessInformation.areCompanyAddressesEqual');

    return (
        <Grid gap={24}>
            <AddressFormPart prefix='registeredAddress' />

            <Form.Part>
                <Checkbox name='businessInformation.areCompanyAddressesEqual' data-qa='areCompanyAddressesEqual'>
                    {messages.tradingAddressEqualsRegAddress}
                </Checkbox>
            </Form.Part>

            {!areCompanyAddressesEqual && (
                <Grid gap={16}>
                    <Text font='headline' fontSize='xxsmall' fontWeight='medium'>
                        {messages.tradingAddress}
                    </Text>

                    <AddressFormPart prefix='tradingAddress' />
                </Grid>
            )}
        </Grid>
    );
});

StepForm.displayName = 'StepForm';
